import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { map, withLatestFrom, debounceTime, concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  GetAssetStatus,
  GetAssetStatusSuccess,
  GetAssetStatusError,
} from '../action-creators';
import AppState from '../../state';
import { GET_ASSET_STATUS_SUCCESS, GET_ASSET_STATUS_ERROR } from '../actions';
import { NoOp } from '../../ui/action-creators';

export const retryGetStatusEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, GetAssetStatusSuccess | GetAssetStatusError>(
      GET_ASSET_STATUS_SUCCESS,
      GET_ASSET_STATUS_ERROR
    ),
    debounceTime(2500),
    withLatestFrom(state$),
    map(([action, state]) => {
      const ids = Object.keys(state.assets.assets).filter((t) => {
        if (t in state.assets.statuses) {
          const status = state.assets.statuses[t];

          return !status.validationDone || !status.acrDone;
        }
        return true;
      });

      const correctLocation =
        state.router.location.pathname.startsWith('/release') ||
        state.router.location.pathname.startsWith('/music-video');

      if (!ids.length || !correctLocation || action.retryCounter > 10) {
        return [new NoOp()];
      }

      const byCategory = ids.reduce((memo: Record<string, string[]>, id) => {
        const asset = state.assets.assets[id];
        const url = new URL(asset.url);
        const category = url.pathname.split('/')[1];

        if (!(category in memo)) {
          memo[category] = [];
        }

        memo[category].push(id);

        return memo;
      }, {});

      return Object.keys(byCategory).map((category) => {
        return new GetAssetStatus(
          category,
          byCategory[category],
          action.retryCounter + 1
        );
      });
    }),
    concatMap((actions) => actions)
  );
